import { useMutation, MutationHookOptions, gql } from "@apollo/client"

const BulkUpdateTerminations = gql`
  mutation BulkAddTmsToInProgress(
    $bulkOffboardingId: ID!
    $params: [BulkAddToInProgressTerminationInputType!]!
  ) {
    bulkAddTmsToInProgress(input: { bulkOffboardingId: $bulkOffboardingId, params: $params }) {
      errors
    }
  }
`

export const useBulkAddTmsToInProgress = (options?: MutationHookOptions) => {
  return useMutation(BulkUpdateTerminations, options)
}
